var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDcent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 46 52",
    className: "default-thema",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.426 9.819l3.875-2.237v-5.345l-3.875-2.237z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.161 33.085v-15.033l12.949-7.472v-10.58l-21.452 12.386a1.314 1.314 0 0 0-.658 1.14v24.774l.007.073z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.991 46.69l-12.957 7.487-12.883-7.443-9.161 5.293 21.386 12.35a1.322 1.322 0 0 0 1.316 0l21.453-12.386.015-.007z",
    transform: "translate(-.266 -12.552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.893 15.136l-8.5-4.906v5.337l-9.143 5.279 9.139 5.272v9.622l9.161 5.286v-24.749a1.346 1.346 0 0 0-.657-1.141z",
    transform: "translate(27.236 7.48) translate(-37.25 -10.23)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.228 23.288l.007 10.478 8.891-5.133v-10.478z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcent);
export default __webpack_public_path__ + "static/media/dcent.af5b0bc03909454d67f4ee11fe1d907b.svg";
export { ForwardRef as ReactComponent };